module.exports = __webpack_public_path__ + "assets/zurb-foundation.d31fd310.svg";